/**
 * Files are uploaded base64-encoded in JSON, 4 bytes for every 3, and the API takes requests of up to 50 MB
 * (RequestLimits in the API), so a file of just over 37.5 MB fills a request. Check the size before uploading: the API
 * answers a larger request with 413 and a message, but a browser that's still sending the file gets a reset connection
 * instead of that answer.
 */
export default new class FileUploadAssistant {
  /** The largest file the API takes, in MB (MiB): the API's RequestLimits.MaxUploadFileSizeMB */
  public readonly maxFileSizeMB = 37

  public isTooLarge(size: number): boolean {
    return size >= this.maxFileSizeMB * 1024 * 1024
  }

  /** Without a file name, the message the API answers a request that's too large with (413) */
  public tooLargeMessage(fileName?: string): string {
    const subject = fileName ? `"${fileName}"` : 'This file'
    return `${subject} is too large to upload. Files must be smaller than ${this.maxFileSizeMB} MB.`
  }
}()
